if (!customElements.get('nav-menu')) {
  class NavMenu extends HTMLElement {
    dialog = undefined;
    selectors = {
      dialog: 'dialog',
      content: '.js-dialog-content',
      close: '.js-nav-close',
      linksContainer: '.js-nav-links',
      link: '.js-nav-link',
      sublinksContainer: '.js-nav-sublinks',
      sublink: '.js-nav-sublink',
      back: '.js-nav-back',
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');

      this.querySelector(this.selectors.close)?.addEventListener('click', () => this.closeDialog());

      // Close dialog on clicking outside content
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) {
          this.closeDialog();
        }
      });

      const links = this.querySelectorAll(this.selectors.link);
      links.forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          const submenuLabel = link.getAttribute('aria-controls');
          this.setActiveSubmenu(submenuLabel);
          this.toggleMenuContainers();
        });
      });

      this.querySelectorAll(this.selectors.back).forEach(backButton => {
        backButton.addEventListener('click', (event) => {
          this.toggleMenuContainers();
        });
      });
    }

    /**
     * Open the dialog with a slide-in animation.
     */
    openDialog() {
      this.dialog.showModal();
      setTimeout(() => {
        this.dialog.classList.add('is-open');
      });
    }

    /**
     * Close the dialog with a slide-out animation.
     */
    closeDialog() {
      // Add closing class to trigger slide out
      this.dialog.classList.add('closing');

      // Wait for transition to finish before closing
      this.dialog.querySelector(this.selectors.content).addEventListener('transitionend', () => {
        this.dialog.close();
        this.dialog.classList.remove('closing');
        this.dialog.classList.remove('is-open');
        this.resetToMainMenu();
      }, { once: true });
    }

    /**
     * Reset the menu to the main menu state.
     */
    resetToMainMenu() {
      const sublinks = this.querySelector(this.selectors.sublinksContainer);
      const linksContainer = this.querySelector(this.selectors.linksContainer);

      // Remove active class from all sublinks
      sublinks.querySelector('.is-active')?.classList.remove('is-active');

      // Reset to main menu
      sublinks.classList.remove('is-active');
      linksContainer.classList.add('is-active');
    }

    toggleMenuContainers() {
      const sublinks = this.querySelector(this.selectors.sublinksContainer);
      const linksContainer = this.querySelector(this.selectors.linksContainer);
      sublinks.classList.toggle('is-active');
      linksContainer.classList.toggle('is-active');
    }

    /**
     * Set active submenu.
     *
     * @param {String} submenu
     */
    setActiveSubmenu(submenuLabel) {
      const submenus = this.querySelector(this.selectors.sublinksContainer);
      const submenu = submenus.querySelector(`[aria-label="${submenuLabel}"]`);

      if (!submenu) {
        return;
      }

      // Remove active class from all sublinks
      submenus.querySelector('.is-active')?.classList.remove('is-active');
      submenu.classList.add('is-active');
    }
  }
  customElements.define('nav-menu', NavMenu);

  // Open the nav menu dialog when the opener is clicked
  document.querySelector('.js-nav-menu-opener').addEventListener('click', (event) => {
    event.preventDefault();
    const navMenu = document.querySelector('nav-menu');
    if (navMenu) {
      navMenu.openDialog();
    }
  });
}
